module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isCheckWireModalVisible) ? _c('checkwire', {
    attrs: {
      "closeAction": _vm.loadFundingSourceAfterModalSave
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "breadcrumbsData": _vm.breadcrumbData
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.userDetailLoading || _vm.accountUsersLoading || _vm.noteLoading || _vm.fundingLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("\n          " + _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " - " + _vm._s(_vm.getAccountType()) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.account.accountId) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.account.createdAt)) + " ")])])]), _vm._v(" "), (_vm.account.investorSince) ? _c('div', {
    staticClass: "info-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.account.investorSince) + " ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-value"
  }, [_c('div', {
    staticClass: "space-between"
  }, [(_vm.account.status == 'active') ? _c('p', {
    staticClass: "label label-success capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'pending') ? _c('p', {
    staticClass: "label label-warning capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.status == 'inactive') ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" " + _vm._s(_vm.account.status) + " ")]) : _vm._e(), _vm._v(" "), (_vm.account.hasUserComments) ? _c('p', {
    staticClass: "label label-danger capitalize-text"
  }, [_vm._v(" Comments ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle top-margin"
  }, [_vm._v("\n            Authorized account holders and representatives\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "representatives-section"
  }, [_c('p', {
    staticClass: "label-names"
  }, [_vm._v("Name:")]), _vm._v(" "), _c('div', {
    staticClass: "representatives-list"
  }, _vm._l((_vm.accountRepresentatives), function(representative, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n                  " + _vm._s(representative.fullName) + "\n                ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n            Note list\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg btn-full-mobile top-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToPurchaseInvestmentNote()
      }
    }
  }, [_vm._v("\n            Make an investment\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "balance-section"
  }, [_c('span', {
    staticClass: "panel-subtitle"
  }, [_vm._v("Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.currentAmountBalance)))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle top-margin bottom-margin"
  }, [_vm._v("\n              Notes list\n          ")]), _vm._v(" "), (_vm.notes.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 No notes found.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.notes.length > 0) ? _c('div', {
    staticClass: "notes-container"
  }, [_c('div', {
    staticClass: "notes-table-desktop",
    class: {
      'table-fixed-header--md cols-9': _vm.notes.length > 6
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.notes), function(note, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "notes-cards-mobile"
  }, _vm._l((_vm.notes), function(note, index) {
    return _c('div', {
      key: index,
      staticClass: "note-card"
    }, [_c('div', {
      staticClass: "note-card-header"
    }, [_c('div', {
      staticClass: "note-card-title"
    }, [_vm._v("Note #" + _vm._s(note.noteId))]), _vm._v(" "), (note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "note-card-body"
    }, [_c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Term:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Rate:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Principal amount:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Purchase date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Open date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-row"
    }, [_c('span', {
      staticClass: "note-card-label"
    }, [_vm._v("Maturity date:")]), _vm._v(" "), _c('span', {
      staticClass: "note-card-value"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "note-card-footer"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline btn-block",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("\n            Bank account\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "action-button-container"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg btn-full-mobile",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.openCheckWireModal()
      }
    }
  }, [_vm._v("Add check or wire transfer")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-subtitle top-margin bottom-margin"
  }, [_vm._v("\n          Account list\n          ")]), _vm._v(" "), (_vm.fundingSources.length === 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 No bank accounts were found.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.fundingSources.length > 0) ? _c('div', {
    staticClass: "funding-container"
  }, [_c('div', {
    staticClass: "funding-table-desktop",
    class: {
      'table-fixed-header--sm cols-5': _vm.fundingSources.length > 3
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(funding.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.status === 'verified') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.userAccount.defaultFundingSourceId),
        expression: "userAccount.defaultFundingSourceId"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.userAccount.defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showDefaultFundingSourceConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.userAccount.defaultFundingSourceId = funding.id
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(funding.type !== 'check' && funding.type !== 'wire-transfer') ? _c('span', {
      staticClass: "label",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                        " + _vm._s(funding.status) + "\n                      ")]) : _vm._e()])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "funding-cards-mobile"
  }, _vm._l((_vm.fundingSources), function(funding, index) {
    return _c('div', {
      key: index,
      staticClass: "funding-card"
    }, [_c('div', {
      staticClass: "funding-card-header"
    }, [_c('div', {
      staticClass: "funding-card-title"
    }, [_vm._v(_vm._s(funding.name))]), _vm._v(" "), (funding.type !== 'check' && funding.type !== 'wire-transfer') ? _c('span', {
      staticClass: "label",
      class: funding.status === 'verified' ? 'label-success' : 'label-warning'
    }, [_vm._v("\n                    " + _vm._s(funding.status) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-body"
    }, [_c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Bank name:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_vm._v(_vm._s(funding.bankName ? funding.bankName : '-----'))])]), _vm._v(" "), _c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Type:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_vm._v(_vm._s(_vm.formatType(funding.type, 'investor')))])]), _vm._v(" "), (funding.status === 'verified') ? _c('div', {
      staticClass: "funding-card-row"
    }, [_c('span', {
      staticClass: "funding-card-label"
    }, [_vm._v("Default:")]), _vm._v(" "), _c('span', {
      staticClass: "funding-card-value"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.userAccount.defaultFundingSourceId),
        expression: "userAccount.defaultFundingSourceId"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": funding.id,
        "checked": _vm._q(_vm.userAccount.defaultFundingSourceId, funding.id)
      },
      on: {
        "change": function($event) {
          _vm.showDefaultFundingSourceConfirmationModal({
            fundingSource: funding
          })
        },
        "__c": function($event) {
          _vm.userAccount.defaultFundingSourceId = funding.id
        }
      }
    })])]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("\n            Account preference\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "preferences-container"
  }, [_c('div', {
    staticClass: "preference-item"
  }, [_c('div', {
    class: _vm.account.paymentPreference === 'reinvest' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.paymentPreference),
      expression: "account.paymentPreference"
    }],
    attrs: {
      "id": "ritema",
      "name": "ritem",
      "type": "radio"
    },
    domProps: {
      "value": 'reinvest',
      "checked": _vm._q(_vm.account.paymentPreference, 'reinvest')
    },
    on: {
      "change": function($event) {
        _vm.showConfirmationModal('reinvest')
      },
      "__c": function($event) {
        _vm.account.paymentPreference = 'reinvest'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritema"
    }
  }, [_vm._v(_vm._s(_vm.formatPaymentPreference('reinvest')))])])]), _vm._v(" "), _c('div', {
    staticClass: "preference-item"
  }, [_c('div', {
    class: _vm.account.paymentPreference === 'payout' ? 'radio-item radio-item-repay' : 'radio-item radio-item-repay radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.paymentPreference),
      expression: "account.paymentPreference"
    }],
    attrs: {
      "id": "ritemb",
      "name": "ritem",
      "type": "radio"
    },
    domProps: {
      "value": 'payout',
      "checked": _vm._q(_vm.account.paymentPreference, 'payout')
    },
    on: {
      "change": function($event) {
        _vm.showConfirmationModal('payout')
      },
      "__c": function($event) {
        _vm.account.paymentPreference = 'payout'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemb"
    }
  }, [_vm._v(_vm._s(_vm.formatPaymentPreference('payout')))])])]), _vm._v(" "), _c('div', {
    staticClass: "preference-item"
  }, [_c('div', {
    class: _vm.account.paymentPreference === 'donate' ? 'radio-item' : 'radio-item radio-item-unselected'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.paymentPreference),
      expression: "account.paymentPreference"
    }],
    attrs: {
      "id": "ritemc",
      "name": "ritem",
      "type": "radio"
    },
    domProps: {
      "value": 'donate',
      "checked": _vm._q(_vm.account.paymentPreference, 'donate')
    },
    on: {
      "change": function($event) {
        _vm.showConfirmationModal('donate')
      },
      "__c": function($event) {
        _vm.account.paymentPreference = 'donate'
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "ritemc"
    }
  }, [_vm._v(_vm._s(_vm.formatPaymentPreference('donate')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  })])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Account\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Id:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Date created:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Investor since:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-label"
  }, [_c('label', [_vm._v("Status:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Note number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Term")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Principal amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Purchase date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Open date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Maturity date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bank name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Account name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Default")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70adab28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDetail.vue
// module id = 2169
// module chunks = 1